"use client";

import { ExternalLink } from "lucide-react";
import { useRouter } from "next/navigation";

import { Button } from "@/app/_module/components/ui/button";

interface ViewLeadButtonProps {
  leadId: string;
  // Name or number on the card, so a screen reader hears which lead.
  contactName: string;
}

// Same push as the dialer's in-call "View Lead". This page is also embedded
// at /m/communication, where the lead screen is /m/leads/<id>.
export const ViewLeadButton = function({ leadId, contactName }: ViewLeadButtonProps) {
  const router = useRouter();

  return (
    <Button
      variant="outline"
      size="sm"
      className="text-xs h-7 px-2 shrink-0"
      aria-label={`View Lead for ${contactName}`}
      onClick={(e) => {
        e.stopPropagation();
        const shell = window.location.pathname.startsWith("/m") ? "/m" : "";
        router.push(`${shell}/leads/${leadId}`);
      }}
    >
      <ExternalLink className="h-3 w-3 mr-1" />
      View Lead
    </Button>
  );
};
